import React from 'react';

import { showAlert } from 'components/shared/Alert/Alert';
import Confirm from 'components/shared/Modal/Confirm/Confirm';

import { deleteCustomFormCheck } from '../../lib/deleteCustomFormCheck';
import { CurrentMedications as initialValue } from '../../CustomFormInitialStates';

const DeleteMedication = ({
  currentMedications,
  setCurrentMedications,
  syncMedicationsAndClinicalNotes,
  handleNoDetails,
  setConfirmationModal,
  confirmationModal,
  medicationToDelete,
  setMedicationToDelete
}) => {
  const handleDeleteRow = (id) => {
    if (currentMedications?.noDetails) return handleNoDetails(true);

    if (!currentMedications?.medications[0]?.id && !id) {
      showAlert({
        title: 'Medications',
        message: 'Please create a medication before deleting one.',
        color: 'warning'
      });

      return setCurrentMedications(initialValue);
    }

    const updatedObject = {
      ...currentMedications,
      medications: currentMedications.medications.filter((row) => row.id !== id)
    };

    syncMedicationsAndClinicalNotes(updatedObject);
  };

  return (
    confirmationModal && (
      <Confirm
        variant="danger"
        title="Delete medications"
        icon="trash-mono"
        message={
          deleteCustomFormCheck(medicationToDelete, currentMedications?.medications)
            ? 'Are you sure you want to delete this medication?'
            : 'Are you sure you want to delete this form?'
        }
        handleOpen={confirmationModal}
        handleClose={() => setConfirmationModal(false)}
        footerActions={{
          primary: {
            text: 'Delete',
            onClick: () => {
              handleDeleteRow(medicationToDelete);
              setMedicationToDelete(null);
              setConfirmationModal(false);
            },
            color: 'danger'
          }
        }}
      />
    )
  );
};

export default DeleteMedication;
